import { IS_LOADING, IS_LOADED, SHOW_ERROR, CLEAR_ERROR, USER_REGISTERED, USER_LOGIN, REMOVE_TOKEN, UPDATE_USER, CHANGE_PAGE, SAVE_OPERATORID, CHANGE_LANGUAGE, CHANGE_NAV, CHANGE_COUNTER, SAVE_USER_TOKEN, SAVE_COUNTRY } from "../actions/type";
import i18n from "../../i18n";

// Function to add our give data into cache
const addDataIntoCache = (cacheName, url, response) => {
	// Converting our response into Actual Response form
	const data = new Response(JSON.stringify(response));

	if ('caches' in window) {
		// Opening given cache and putting our data into it
		caches.open(cacheName).then((cache) => {
			cache.put(url, data);
		});
	}
};

export const getCacheData = (cacheName, url) => {
	return caches.open(cacheName)
		.then((cache) => {
			return cache.match(url)
				.then(res => {
					if (res) {
						return res.json()
					}
					return null
				})
				.catch(err => {
					console.log(err)
					return null
				})
		})
		.catch(err => {
			console.log(err)
			return null
		})
}

const removeCacheData = (cacheName, url) => {
	if (("caches" in window)) {
		caches.open(cacheName)
			.then(cache => {
				cache.delete(url)
			})
	}
};

const initState = {
	isLoading: false,
	error: null,
	token: localStorage.getItem("laundry-user") || null,
	isAuthenticated: false,
	user: null,
	authProgress: "landing",
	operatorId: localStorage.getItem("operatorId"),
	language: localStorage.getItem("language") || window.navigator.language.substring(0, 2),
	nav: "stamp",
	modalCounter: localStorage.getItem("counter") || 0,
	loginId: localStorage.getItem("loyalty-login-id") || null,
	country: localStorage.getItem("country") || "Malaysia",
	environment: "production", // for einvoice validation link
};

const userReducer = (state = initState, action) => {
	// console.log(action);
	switch (action.type) {
		case IS_LOADING:
			return {
				...state,
				isLoading: true
			};
		case IS_LOADED:
			return {
				...state,
				isLoading: false
			};
		case SHOW_ERROR:
			return {
				...state,
				error: action.payload
			};
		case CLEAR_ERROR:
			return {
				...state,
				error: null
			};
		case CHANGE_PAGE:
			return {
				...state,
				authProgress: action.payload,
				error: null
			};
		case CHANGE_NAV:
			return {
				...state,
				nav: action.payload,
				error: null
			};
		case USER_REGISTERED:
			return {
				...state,
				authProgress: action.payload.login && !action.payload.register ? "login" : action.payload.register && !action.payload.login ? "register" : "landing"
			};
		case USER_LOGIN:
			let id = state.loginId
			if (!state.loginId) {
				id = `${action.payload.user.store}:${action.payload.user.memberId}`
				localStorage.setItem("loyalty-login-id", id);
			} else {
				if (state.loginId.split(",").filter(data => data === `${action.payload.user.store}:${action.payload.user.memberId}`).length <= 0) {
					id = state.loginId.concat(`,${action.payload.user.store}:${action.payload.user.memberId}`)
					localStorage.setItem("loyalty-login-id", id);
				}
			}
			localStorage.setItem("laundry-user", action.payload.token);
			addDataIntoCache('laundry-user', "/token", action.payload.token) // token in safari localstorage will missing
			return {
				...state,
				user: {
					...action.payload.user,
					voucherScheduler: state.user && state.user.voucherScheduler ? state.user.voucherScheduler : [],
					pointHistory: state.user && state.user.pointHistory ? state.user.pointHistory : [],
					tokenPurchaseHistory: state.user && state.user.tokenPurchaseHistory ? state.user.tokenPurchaseHistory : [],
					transferToken: state.user && state.user.transferToken ? state.user.transferToken : [],
					transactions: state.user && state.user.transactions ? state.user.transactions : [],
				},
				token: action.payload.token,
				isAuthenticated: true,
				authProgress: "landing",
				loginId: id,
				environment: action.payload.environment,
			};
		case UPDATE_USER:
			if (action.payload.type === "image") {
				return {
					...state,
					user: {
						...state.user,
						profilePicture: action.payload.data
					}
				};
			} else if (action.payload.type === "name") {
				return {
					...state,
					user: {
						...state.user,
						name: action.payload.data
					}
				};
			} else if (action.payload.type === "email") {
				return {
					...state,
					user: {
						...state.user,
						email: action.payload.data
					}
				};
			} else if (action.payload.type === "number") {
				return {
					...state,
					user: {
						...state.user,
						number: action.payload.data
					}
				};
			} else if (action.payload.type === "stamp") {
				return {
					...state,
					user: {
						...state.user,
						...action.payload.data
					}
				};
			} else if (action.payload.type === "birthday") {
				return {
					...state,
					user: {
						...state.user,
						birthday: action.payload.data
					}
				};
			} else if (action.payload.type === "voucher") {
				return {
					...state,
					user: {
						...state.user,
						vouchers: action.payload.voucher,
						voucherScheduler: action.payload.voucherScheduler
					}
				};
			} else if (action.payload.type === "voucherScheduler") {
				return {
					...state,
					user: {
						...state.user,
						voucherScheduler: action.payload.voucherScheduler,
						externalVoucherCode: action.payload.externalVoucherCode
					}
				};
			} else if (action.payload.type === "transaction") {
				return {
					...state,
					user: {
						...state.user,
						pointHistory: action.payload.pointHistory,
						tokenPurchaseHistory: action.payload.tokenPurchaseHistory,
						transferToken: action.payload.transferToken,
					}
				};
			} else if (action.payload.type === "dashboard") {
				return {
					...state,
					user: {
						...state.user,
						transactions: action.payload.transactions,
					}
				};
			} else if (action.payload.type === "profile") {
				return {
					...state,
					user: {
						...state.user,
						...action.payload.data
					}
				};
			}
			break;
		case REMOVE_TOKEN:
			localStorage.removeItem("laundry-user");
			removeCacheData('laundry-user', "/token")
			localStorage.removeItem("counter");
			return {
				...state,
				token: null,
				isLoading: false,
				error: null,
				isAuthenticated: false,
				user: null,
				authProgress: "landing",
				modalCounter: 0
			};
		case SAVE_OPERATORID:
			localStorage.setItem("operatorId", action.payload);
			//addDataIntoCache('operatorId', `https://${window.location.hostname}`, action.payload)
			return {
				...state,
				operatorId: action.payload
			};
		case SAVE_USER_TOKEN:
			localStorage.setItem("laundry-user", action.payload);
			addDataIntoCache('laundry-user', "/token", action.payload)
			return {
				...state,
				token: action.payload,
			};
		case CHANGE_LANGUAGE:
			localStorage.setItem("language", action.payload);
			i18n.changeLanguage(action.payload);
			return {
				...state,
				language: action.payload
			};
		case CHANGE_COUNTER:
			localStorage.setItem("counter", action.payload);
			return {
				...state,
				modalCounter: action.payload
			};
		case SAVE_COUNTRY:
			localStorage.setItem("country", action.payload);
			return {
				...state,
				country: action.payload,
			};
		default:
			return state;
	}
};

export default userReducer;
